import React from 'react'

import { Box, Item, Text } from '@factorialco/deprecated-design-system'

import DropdownSearchBar from 'modules/core/components/DropdownSearchBar'
import i18n from 'modules/core/lib/i18n'

import { A3InnuvaMapping } from 'modules/payroll_integrations_a3innuva/lib/types'

interface Props {
  mappings: A3InnuvaMapping[]
  options: Item[]
  onMappingChanged: (mappings: A3InnuvaMapping[]) => void
}

const getInitialValue = (options: Item[], mapping?: A3InnuvaMapping) => {
  if (!mapping) return ''

  const currentOption = options.find((option) => option.value === mapping.a3innuva_id)
  if (!currentOption) return ''

  return currentOption.label
}

export const DefaultValue = ({ mappings, options, onMappingChanged }: Props) => {
  const currentMappings = mappings.find(({ factorial_id }) => factorial_id === 'default')
  const [selectedValue, setSelectedValue] = React.useState<string>(
    getInitialValue(options, currentMappings)
  )

  const mapLevel = (selectedItem: Item) => {
    const defaultId = 'default'
    const a3jobPositionId = selectedItem.value.toString()
    let isLevelMapped = false
    let newMappings: A3InnuvaMapping[] = []
    newMappings = mappings.reduce((filteredMappings, mapping) => {
      const newMapping = { ...mapping }
      if (newMapping.factorial_id !== defaultId) {
        // If is not the target do nothing
        filteredMappings.push(newMapping)
        return filteredMappings
      }

      isLevelMapped = true
      // If the value selected is none, we remove the mapping
      if (selectedItem.value === '') return filteredMappings

      newMapping.a3innuva_id = a3jobPositionId
      return filteredMappings
    }, newMappings)

    if (!isLevelMapped) {
      newMappings.push(createMapping(defaultId, a3jobPositionId))
    }

    setSelectedValue(selectedItem.label)
    onMappingChanged(newMappings)
  }

  const createMapping = (defaultId: string, a3jobPositionId: string): A3InnuvaMapping => {
    return {
      factorial_id: defaultId,
      a3innuva_id: a3jobPositionId,
    }
  }

  return (
    <Box gap="s12">
      <Text.Normal>
        {i18n.t(
          'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.levels.default_value_description'
        )}
      </Text.Normal>
      <Box
        flexDirection="row"
        justifyContent="spaceBetween"
        alignItems="center"
        maxWidth="s600"
        gap="s12"
      >
        <Box
          paddingBottom="s32"
          width="s600"
          border={{
            bottom: {
              width: 's1',
              style: 'solid',
              color: 'grey400',
            },
          }}
        >
          <DropdownSearchBar
            name={selectedValue}
            placeholder={i18n.t(
              'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.cost_center.select'
            )}
            label=""
            onSelect={(value) => mapLevel(value)}
            labelNotFound={i18n.t('common.none')}
            data={options}
            searchLabel={i18n.t('common.search')}
            autofocus={false}
            ellipsis={false}
            popoverWidth="s400"
          />
        </Box>
      </Box>
    </Box>
  )
}
